import { selectUserRoleNames } from '@bo-services/authenticationSlice';
import { useSelector } from 'react-redux';

export const useRoleChecker = () => {
  const userRoles = useSelector(selectUserRoleNames);

  const isPaymentsAdmin = userRoles.includes('Payments Admin');
  const isSuperUser = userRoles.includes('Super User');

  return {
    isPaymentsAdmin,
    isSuperUser
  };
};
